module.exports = __webpack_public_path__ + "static/bride-window-short-627f4cf7b6607d41341359c4e45a4470.jpg";